
export const credentials = {
    customer: [
      { username: 'superadmin', password: 'S00per@2023' },
      { username: 'user1', password: 'User@2024' },
      { username: 'guest', password: 'Guest@2025' },
    ],
    admin: [
      { username: 'trial_admin', password: 'Tri@l@2025' },
      { username: 'admin2', password: 'Admin@2024' },
      { username: 'tracey.rawlinson@kjr.com.au', password: 'Tracey@2025' },
      { username: 'abby.solway@kjr.com.au', password: 'Abby@2025' }
    ],
  };
  